import React, { useEffect, useMemo, useState } from "react";
import { Button, message, Modal } from "antd";
import { ModalProps } from "antd/es/modal";
import style from "./index.module.scss";
import UploadImageBtn from "./components/UploadImageBtn";
import { getExamById } from "../../../../../API";
import useRequest from "../../../../../Utils/useRequest";

interface ExamUploadModalProps extends ModalProps {
    onCancel: () => void;
    onUploadOk: () => void;
    onSubmit: (count: number) => void;
    examId: string; //考试id
    isAfter: boolean; //当前考核是否已结束
}

export default function ExamUploadModal({
    isAfter,
    onCancel,
    onUploadOk,
    onSubmit,
    examId,
    ...modalProps
}: ExamUploadModalProps) {
    const [filesNum, setFilesNum] = useState(0);
    const [examInfo] = useRequest(() => getExamById(examId), {}, [examId]);

    //监听考试是否已结束，结束后回到列表页
    useEffect(() => {
        if (isAfter) {
            message.info("考试已结束");
            onCancel();
        }
    }, [isAfter]);

    const title = useMemo(() => {
        return (
            <div>
                <div>上传作答内容</div>
                <div className={style.examName}>
                    考核名称：{examInfo?.examinfo?.name}
                </div>
            </div>
        );
    }, [examInfo?.examinfo?.name]);

    const footer = (
        <div className={style.footer}>
            <span>上传附件数：{filesNum}</span>

            <Button
                type="primary"
                onClick={() => onSubmit(filesNum)}
                disabled={isAfter}>
                交卷
            </Button>
        </div>
    );
    return (
        <Modal
            title={title}
            footer={footer}
            closable={false}
            onCancel={onCancel}
            className={style.root}
            {...modalProps}>
            <UploadImageBtn
                handleFilesNum={setFilesNum}
                examId={examId}
                isAfter={isAfter}
            />
        </Modal>
    );
}
